import { CalendarPlanShowcaseConfigTeaser } from '@yandex-int/k-common/typings';
import b from 'b_';
import { ShowcaseCard, SimpleCallback } from 'platform-components/common';
import { ShowcaseLesson } from 'platform-components/src/components/showcase-card/schowcase-card';
import {
    ShowcaseLessonTeaser,
    ShowcaseLessonTeaserCard,
} from 'platform-components/src/components/showcase-lesson-teaser-card/showcase-lesson-teaser-card';
import React from 'react';

import { ArrowButton } from '../__arrow-button/calendar-plan-showcase__arrow-button';
import { CalendarPlanShowcaseCarouselNextCardBlock } from '../__carousel-next-card-block/calendar-plan-showcase__carousel-next-card-block';

import './calendar-plan-showcase__carousel.scss';

interface Props {
    card: ShowcaseLesson | ShowcaseLessonTeaser;
    lessonTeaserConfig?: CalendarPlanShowcaseConfigTeaser;
    onLessonClick?: SimpleCallback;
    nextCard?: ShowcaseLesson | ShowcaseLessonTeaser;
    onNextCardClick?: SimpleCallback;
    hasPrevCard?: boolean;
    onPrevCardClick?: SimpleCallback;
    onTeaserOpenPlanButtonClick?: SimpleCallback;
    onTeaserUploadPlanButtonClick?: SimpleCallback;
}

function isLessonCard(card: ShowcaseLesson | ShowcaseLessonTeaser): card is ShowcaseLesson {
    return (card as ShowcaseLesson).name !== undefined;
}

export const CalendarPlanShowcaseCarousel = ({
    card,
    lessonTeaserConfig,
    onLessonClick,
    nextCard,
    onNextCardClick,
    hasPrevCard,
    onPrevCardClick,
    onTeaserOpenPlanButtonClick,
    onTeaserUploadPlanButtonClick,
}: Props) => {
    const isTeaserAvailable = lessonTeaserConfig !== undefined;
    const hasNextCard = nextCard && (isLessonCard(nextCard) || isTeaserAvailable);

    function getCardView() {
        if (isLessonCard(card)) {
            return <ShowcaseCard lesson={card} onPreviewClick={onLessonClick} />;
        }

        if (isTeaserAvailable) {
            return (
                <ShowcaseLessonTeaserCard
                    onOpenPlanButtonClick={onTeaserOpenPlanButtonClick}
                    onUploadPlanButtonClick={onTeaserUploadPlanButtonClick}
                    teaser={card}
                    teaserConfig={lessonTeaserConfig!}
                />
            );
        }

        return null;
    }

    function getNextCardView() {
        if (!nextCard) {
            return null;
        }

        if (isLessonCard(nextCard)) {
            return <ShowcaseCard lesson={nextCard} />;
        }

        if (isTeaserAvailable) {
            return <ShowcaseLessonTeaserCard teaser={nextCard} teaserConfig={lessonTeaserConfig!} />;
        }

        return null;
    }

    return (
        <div className={b('calendar-plan-showcase', 'carousel')}>
            <div className={b('calendar-plan-showcase', 'carousel-card')}>{getCardView()}</div>

            {hasNextCard && (
                <CalendarPlanShowcaseCarouselNextCardBlock onClick={onNextCardClick}>
                    {getNextCardView()}
                </CalendarPlanShowcaseCarouselNextCardBlock>
            )}

            {hasNextCard && <ArrowButton direction={ArrowButton.DIRECTION.RIGHT} onClick={onNextCardClick} />}

            {hasPrevCard && <ArrowButton direction={ArrowButton.DIRECTION.LEFT} onClick={onPrevCardClick} />}
        </div>
    );
};
